import { ModalRef } from './modal-ref';
import { ModalTemplateType } from './templates';
import { Observable } from 'rxjs';

export interface ModalOptions {
  template?: ModalTemplateType;
  disableOverlayClosing?: boolean;
  data?: any;
  closeAfterRouteChange?: boolean;
  dataObservable$?: Observable<any>;
}

export abstract class Modal {
  instance: ModalRef;
  options: ModalOptions;

  close(output?: any): void {
    this.instance.close(output);
  }

  dismiss(output?: any): void {
    this.instance.dismiss(output);
  }
}
